export const ERROR_MESSAGES = {
    dobv: {
        required: 'Please enter Date of Birth!'
    },
    phone: {
        required: 'Please enter Last 4 digits of Phone!',
        maxLength: 'Number should be of 4 digits',
        pattern: 'Enter Numbers only'
    },
    vehicleno: {
        required: 'Please enter Vehicle Registration Number!',
        pattern: 'Enter Alphanumeric only'
    },
    vinnumber: {
        required: 'Please enter VIN Number!',
        pattern: 'Enter Alphanumeric only'
    }
};
